import { render, staticRenderFns } from "./QuestionCategoryBackUp.vue?vue&type=template&id=0afcd2f2&scoped=true"
import script from "./QuestionCategoryBackUp.vue?vue&type=script&lang=js"
export * from "./QuestionCategoryBackUp.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategoryBackUp.vue?vue&type=style&index=0&id=0afcd2f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afcd2f2",
  null
  
)

export default component.exports